module.exports = __webpack_public_path__ + "img/img2@2x.99f9a82d.png";